import { merge as ObservableMerge } from 'rxjs'
import { delay as rxDelay, filter as rxFilter } from 'rxjs/operators'

export default function suggestionsBuilder(builders, textBefore = '', textAfter = '', data = {}) {
  const suppliedIds = []
  return ObservableMerge(...builders.map(builder => builder(textBefore, textAfter, data))).pipe(
    // make async stream
    rxDelay(10),
    // uniq suggestions
    rxFilter(suggestion => {
      if (suggestion && -1 == suppliedIds.indexOf(suggestion.id)) {
        suppliedIds.push(suggestion.id)
        return true
      } else {
        return false
      }
    })
  )
}
